/**
 * Theme Requirements Aggregation for Weidner Apartment Homes
 * 
 * Extends the base blue-haven theme requirements with Weidner Apartment Homes specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-blue-haven/requirements';

/**
 * Weidner Apartment Homes component requirement overrides.
 * Add requirements for any override components here.
 */
const weidnerapartmenthomesOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Weidner Apartment Homes theme.
 * Inherits from blue-haven theme and overrides with Weidner Apartment Homes components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...weidnerapartmenthomesOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
